/*
 *
 * ResultPopUp
 *
 * @version 1.0.0
 * @author Marco Civello
 * @since 23-Jan-2025
 */

import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import AnimationIcon from '@nexidigital/animationicon'
import MerchantModal from '@nexidigital/merchantmodal'
import PortalIcon from '@nexidigital/portalicon'
import { useMobileDetect } from 'Hoc/ListenerProvider'
import { messages } from './languageModule'
import './ResultPopUp.scss'

const ResultPopUp = ({ actions, data }) => {
  const { isExtraSmallScreen } = useMobileDetect()
  const intl = useIntl()
  const { isSuccess, isError, isWarning, title, description, withoutButton } = data
  const { closePopup } = actions

  const handleClose = () => {
    if (typeof data?.onClose === 'function') {
      data.onClose()
    }
    closePopup()
  }

  const handlePrimaryAction = () => {
    if (typeof data?.primaryAction === 'function') {
      data.primaryAction()
    }
    closePopup()
  }

  const renderIcon = () => {
    if (isSuccess) {
      return (
        <div className='icon_success'>
          <AnimationIcon status='success' size='large' loop={false} ariaLabel={intl.formatMessage(messages.successIconAriaLabel)} />
        </div>
      )
    }
    if (isError) {
      return (
        <div className='icon_error'>
          <AnimationIcon status='error' size='large' loop={false} ariaLabel={intl.formatMessage(messages.errorIconAriaLabel)} />
        </div>
      )
    }
    if (isWarning) {
      return (
        <div className='icon_warning'>
          <PortalIcon iconName='warning' iconColor='var(--Color-Surface-Warning-1)' size='l' islink />
        </div>
      )
    }
    return null
  }

  return (
    <div className='result_popup'>
      <MerchantModal
        onClose={handleClose}
        ariaModalTitle={data.isSuccess? intl.formatMessage(messages.successTitle) : data.isError ? intl.formatMessage(messages.failedTitle) : intl.formatMessage(messages.warningTitle) }
        closeLabel={intl.formatMessage(messages.closeLabel)}
        primaryButtonLabel={intl.formatMessage(messages.close)}
        primaryAction={handlePrimaryAction}
        withoutButton={withoutButton || isExtraSmallScreen}>
        <div className='result_popup_content'>
          {renderIcon()}
          {title && <h1 className='result_popup_title'>{title}</h1>}
          {description && <p className='result_popup_description'>{description}</p>}
        </div>
      </MerchantModal>
    </div>
  )
}

ResultPopUp.propTypes = {
  actions: PropTypes.object,
  data: PropTypes.object
}

ResultPopUp.defaultProps = {
  actions: {},
  data: {
    isSuccess: false,
    isError: false,
    isWarning: false,
    title: '',
    description: '',
    withoutButton: false
  }
}

export default ResultPopUp
